import React, {useState, useEffect, useRef, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';
import ConfigUnits from './config-unit';
import {useMenu} from '../../../hooks/useMenu';
import TimeDate from './time-date';

function SetDeviceTag({initiallyDisableKeypress}) {
  const [value, setValue] = useState(10);
  const {onComponent} = useMenu();

  return (
    <TextNumberEntryView
      chars={specialCharTextNumbers}
      focus={3}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={54}
      defaultKey4={50}
      defaultKey5={55}
      defaultKey6={63}
      defaultKey7={65}
      defaultKey8={0}
      defaultKey9={54}
      defaultKey10={50}
      defaultKey11={58}
      defaultKey12={2}
      onSave={() => onComponent(<ConfigUnits />)}
      onLeftHold={() => onComponent(<TimeDate />)}
      title="Set Device Tag"
      caption="Enter a short tag for this device."
      left="Hold to Cancel"
      right="Hold to Save"
      initiallyDisableKeypress={initiallyDisableKeypress}
    />
  );
}

export default SetDeviceTag;
